import { Unspsc } from "src/api-service";

// **************************************************************************
// UNSPSC STATE
// **************************************************************************
export interface UnspscState {
    unspsc: Unspsc | null;
    unspscs: Unspsc[];
    unspscsLoading: boolean;
}

export const initialUnspscState: UnspscState = {
    unspsc: null,
    unspscs: [],
    unspscsLoading: false,
};
